"use strict";
document.addEventListener('DOMContentLoaded', function () {
    // Get the REGSRC argument from the url
    var arg = window.location.search.split('REGSRC=')[1];
    // Proceed if the REGSRC argument was actually in the url
    if (arg) {
        // Get the CTA buttons of the Online Investment page
        var ctas = document.querySelectorAll('.online-investment-cta');
        for (var i = 0; i < ctas.length; i++) {
            // Append the REGSRC argument to the href attribute of the CTA button
            ctas[i].href += 'REGSRC=' + arg;
        }
    }
});
